import "./About.css"

const AboutPart = () => {

    return (
        <>
            <div id="about" className="top-margin container aboutAnimation">
            <h1 className="my-4">About</h1>

            <div className="row ">

                    <div className="col-lg order-lg-1 centerPic mb-4">
                        <img className="img-fluid" src="developerActivity.svg"  alt="profilePic" />
                    </div>

                    <div className="col-lg-7 order-lg-0 code-font">
                        <p className="fs-4">⚡I enjoy developing websites and a keen interest in solving problems and coming up with effective solutions.</p>
                        <p className="fs-4">⚡Enjoy building responsive websites (frontend) using ReactJS, Bootstrap etc.</p>
                        <p className="fs-4">⚡Experience in working on multiple Backened platforms like Node, Express, MongoDB, Postman.</p>
                    </div>

                </div>

            </div>

        </>
    );
};

export const About = () => {
    return (
        <>
            <div className="top-margin container">
                <div className="row">

                    <div className="col-lg order-lg-1 centerPic">
                        <img className="profileDimension picAnimation rounded-circle " src="mohit.jpg" alt="profilePic" />
                    </div>

                    <div className="col-lg-7 order-lg-0">
                        <h1 className="code-font h1Tag-font-size">Hey there!</h1>
                        <h1 id="h1Tag" className="code-font h1Tag-font-size">I am Mohit Sehrawat</h1>
                        <p className="description-font fs-3 mt-4">I am an aspiring Full Stack Developer based in Delhi.</p>
                    </div>

                </div>
            </div>

            <AboutPart />
        </>
    );
};